import React, { useState, useEffect } from 'react';// Import your custom CSS file

// Define the props interface
interface CustomMessageProps {
    content: string;
    duration?: number;
    onClose?: () => void;
}

const CustomMessage: React.FC<CustomMessageProps> = ({ content, duration = 10, onClose }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            if (onClose) onClose();
        }, duration * 1000);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    if (!visible) return null;

    return (
        <div className="custom-message">
            <div className="custom-message-content">
                {content}
            </div>
        </div>
    );
};

export default CustomMessage;
